import './TermsPrivacy.css';

const TermsPrivacy = () => {
    return (
        <div className="terms-privacy-page">
            <div className="terms-privacy-container">
                <h1>Terms & Privacy</h1>
                <p>Read our terms of service and privacy policy.</p>
            </div>
        </div>
    );
};

export default TermsPrivacy;